import React, { Component } from 'react';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import { format } from 'date-fns';


import {LBL_STATUS,LBL_JOIN_DATE_FROM, LBL_DATE_TO, LBL_ALL, LBL_ACTIVE,LBL_DELETED} from '../../configs/labelConfigs';

class FilterAffiliate extends Component {

    constructor(props){
        super(props)
        this.state = {
            includeDate: false, 
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
            statusActive: 'active',
            resetFilterClicked: 0,
            applyFilterClicked: 0,
        }
    }

    onDateCheck = (e) => {
        this.setState({includeDate:!this.state.includeDate}) 
    }

    onStartDateChange = (date) =>{
        let startDate = new Date(date);   
        if(startDate > this.state.selectedEndDate) this.setState({selectedStartDate:startDate,selectedEndDate:startDate});  
        else this.setState({selectedStartDate:startDate});  
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate});  
    }

    onSelectStatus = (e) => {
        this.setState({statusActive:e.target.value})
    } 

    resetFilters = () => { 
        let filtersSelected = 0; 
        this.setState({ 
            includeDate: false, 
            selectedStartDate: new Date(),
            selectedEndDate: new Date(),
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            statusActive: 'active'
        }); 
    }

    sendFilterData = () => {
        let filtersSelected = 0; 
        let fromDate = 0; 
        let endDate = 0;
        if(this.state.includeDate) {
            fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
            endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
            filtersSelected = 1;
        }
        if(this.state.statusActive!=='') {
            filtersSelected = 1;
        }
        
        let filterData = { statusActive:this.state.statusActive, includeDate:this.state.includeDate, selectedStartDate:fromDate, selectedEndDate:endDate, filtersSelected:filtersSelected}; 
        this.props.applyFilters(filterData); 
    }
    
    componentDidUpdate (prevProps) {
        
        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }
            
    }

    render(){

        let {selectedStartDate, selectedEndDate, includeDate, statusActive} = this.state; 

        return(
            <React.Fragment>
               
            <div className="filter-category">
                <h4>{LBL_STATUS}</h4> 
                <div className="form-group">
                    <div className="form-group select-input">
                        <select onChange={(e) => this.onSelectStatus(e)} name="selStatus" value={statusActive} >  
                            <option value='active' >{LBL_ACTIVE}</option>
                            <option value='deleted' >{LBL_DELETED}</option> 
                            <option value="all" >{LBL_ALL}</option>
                        </select>  
                    </div>
                </div>
            </div>
            <div className="filter-category client-filter">
                <div className="row"> 
                    <div className="col-6"> 
                        <h4>
                        <div className="custom-checkbox"> 
                            <input type="checkbox" id="includeDate" name="includeDate" checked={includeDate}  onChange={e => this.onDateCheck(e)} />
                            <label className="checkbox" htmlFor="includeDate" ></label>
                            <label htmlFor="includeDate" > &nbsp; {LBL_JOIN_DATE_FROM} </label> 
                        </div>
                        </h4>
                    </div>
                    <div className="col-6"> <h4>
                        <div className="custom-checkbox"> 
                            <input type="checkbox" id="includeDateTo" name="includeDateTo" />
                            <label className="checkbox not-visible" htmlFor="includeDateTo" ></label>
                            <label htmlFor="includeDateTo" > &nbsp; {LBL_DATE_TO} </label> 
                        </div>
                        </h4></div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-6">
                            <div className="calendar-input">  
                                <DatePicker 
                                    selected={selectedStartDate}
                                    onChange={selected => this.onStartDateChange(selected)}
                                    name="startDate"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Select"
                                    maxDate={new Date()}
                                    // minDate={new Date()}
                                    fixedHeight   
                                    disabled={!includeDate}       
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="calendar-input">  
                                <DatePicker 
                                    selected={selectedEndDate}
                                    onChange={selected => this.onEndDateChange(selected)}
                                    name="endDate"
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Select"
                                    minDate={new Date(selectedStartDate)}
                                    maxDate={new Date()}
                                    fixedHeight     
                                    disabled={!includeDate}         
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
        )
    }

}
export default FilterAffiliate;